import { Button, Input } from '@grofers/react';
import React, { useState } from 'react';
import { Dropdown, Heading, Textarea } from '../../../UiKit';
import { Star } from '../../../UiKit/Star/Star';
import { useBlockUnBlockUser, useGetBlockDeviceReasonCodes } from '../apis';
import Spinner from 'sushiweb/Spinner/Spinner';
import { grey } from 'sushiweb/tokens/color';

const deviceActions = {
  block_device: 'Block',
  unblock_device: 'Unblock',
};

function BlockUnblockDevice() {
  const [customerId, setCustomerId] = useState();
  const [deviceId, setDeviceId] = useState();
  const [action, setAction] = useState();
  const [reason, setReason] = useState();
  const [comment, setComment] = useState();
  const [blockReasonsCodes, setblockReasonsCodes] = useState();

  const { data } = useGetBlockDeviceReasonCodes({
    onSuccess: (data) => {
      setblockReasonsCodes(data?.reasons);
    },
    enabled: action === 'block_device',
  });

  const { mutate, isLoading } = useBlockUnBlockUser(action, {
    onSuccess: () => {
      setCustomerId('');
      setDeviceId('');
      setAction();
      setReason();
      setComment('');
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let queryBody = {
      device_id: deviceId,
      user_id: customerId,
      blocking_reason: reason,
    };
    if (comment?.length) queryBody = { ...queryBody, comments: comment };
    mutate(queryBody);
  };

  const checkMandatoryFields = () => {
    let isDisabled = !customerId || !deviceId || !action;
    if (action === 'block_device') isDisabled = !reason;
    return isDisabled;
  };

  return (
    <form
      className='tw-w-full tw-bg-base-white tw-rounded-2xl tw-p-6 tw-h-max'
      id='device-form'
      onSubmit={handleSubmit}
    >
      <div className='tw-w-full tw-flex tw-flex-col tw-gap-8'>
        <div className='tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-10'>
          <GetIntInputField
            fieldMeta={{
              title: 'Customer ID',
              placeholder: 'Enter Customer ID',
              onChangeHandler: (e) => {
                setCustomerId(e.target.value);
              },
              value: customerId,
            }}
          />
          <GetIntInputField
            fieldMeta={{
              title: 'Device ID',
              placeholder: 'Enter Device ID',
              onChangeHandler: (e) => {
                setDeviceId(e.target.value);
              },
              value: deviceId,
            }}
          />
        </div>
        <div className='w-w-full tw-flex tw-items-center tw-justify-between tw-gap-10'>
          <GetDropdownField
            fieldMeta={{
              title: 'Actions',
              placeholder: 'Select Action',
              onSelectHandler: (val) => {
                setAction(val);
              },
              value: action,
              dropdownList: deviceActions,
              disabled: false,
              isRequired: true,
            }}
          />
          <GetDropdownField
            fieldMeta={{
              title: 'Reasons',
              placeholder: 'Select Reason',
              onSelectHandler: (val) => {
                setReason(val);
              },
              value: reason,
              dropdownList: blockReasonsCodes,
              disabled: !blockReasonsCodes,
              isRequired: action === 'block_device',
            }}
          />
        </div>
        <div className='tw-w-full tw-flex tw-flex-col'>
          <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500 tw-mb-5'>
            Comment
          </div>
          <Textarea
            maxLimit={255}
            showMaxLimit={true}
            showBtn={false}
            placeholder='Please add some comment'
            className='tw-p-5 focus:tw-border-green-500 focus:tw-ring-2 focus:tw-ring-green-500 focus:tw-outline-none'
            height='12rem'
            required
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
            }}
            style={{
              outline: '0.5px solid rgb(207, 207, 207)',
              borderRadius: '8px',
              minHeight: '10rem',
            }}
          />
        </div>
      </div>
      <div className='tw-mt-8'>
        <Button
          onClick={handleSubmit}
          size='medium'
          variant='fill'
          style={{ padding: '1rem 1.7rem' }}
          disabled={checkMandatoryFields()}
        >
          {isLoading ? (
            <Spinner size='small' color={`${grey.z300}`} />
          ) : (
            'Submit'
          )}
        </Button>
      </div>
    </form>
  );
}

const GetIntInputField = ({ fieldMeta }) => {
  const { title, placeholder, onChangeHandler, value } = fieldMeta;
  return (
    <label
      htmlFor='customerIdInput'
      className='tw-w-full tw-flex tw-flex-col tw-gap-1'
    >
      <div>
        <Heading title={title} color='#1F1F1F' weight='600' size='17px' />
        <Star icon='*' />
      </div>
      <Input
        placeholder={placeholder}
        style={{
          padding: '1.22rem 1rem',
          fontWeight: '400',
          fontSize: '1.33rem',
        }}
        onChange={onChangeHandler}
        value={value}
      />
    </label>
  );
};

const GetDropdownField = ({ fieldMeta }) => {
  const {
    title,
    placeholder,
    onSelectHandler,
    value,
    dropdownList,
    disabled,
    isRequired,
  } = fieldMeta;

  return (
    <div
      className={`tw-flex tw-flex-col tw-w-full `}
      css={`
        & div {
          width: 100%;
        },
        ${disabled ? `& div {cursor: not-allowed}` : ''}
        ${disabled ? `& div {pointer-events: none}` : ''}
      `}
    >
      <div
        className={`tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500 ${
          isRequired ? '' : 'tw-mb-2 tw-text-grey-500'
        }`}
      >
        {title}
        {isRequired && <Star icon='*' />}
      </div>
      <Dropdown
        placeholder={placeholder}
        onSelect={onSelectHandler}
        dropdownVal={value}
        dropDownValues={dropdownList}
      />
    </div>
  );
};

export default BlockUnblockDevice;
